import { makeI18nField } from "../utils/i18nSchemas";

export const createRegistrationTicketTypeSchema = {
  body: {
    type: "object",
    required: ["nameI18n", "eventId"],
    properties: {
      nameI18n: makeI18nField({ required: true, minLength: 1 }),
      descriptionI18n: makeI18nField(),
      price: { type: ["string", "null"] },
      eventId: { type: "integer" },
    },
  },
};

export const getAllRegistrationTicketTypesForEventSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "integer" },
    },
  },
};

export const updateRegistrationTicketTypeSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "integer" },
    },
  },
  body: {
    type: "object",
    properties: {
      nameI18n: makeI18nField({ required: true, minLength: 1 }),
      descriptionI18n: makeI18nField(),
      price: { type: ["string", "null"] },
    },
  },
};

export const deleteRegistrationTicketTypeSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "integer" },
    },
  },
};

export const web_createRegistrationTicketTypeSchema =
  createRegistrationTicketTypeSchema.body;

export const web_updateRegistrationTicketTypeSchema =
  updateRegistrationTicketTypeSchema.body;
